<script>
/**
 * Компонент оборачивает каждый элемент переданного слота в указанный css-класс
 *
 * пример использования:
 *
 * ```
 * <WrapDefaultSlotItem
 *     ref="card-content"
 *     class="private-card__content"
 *     item-class="private-card__content-item"
 *     :item-style="contentPositionsVars"
 *     :slots="$slots.default"
 *     :isList="isMobile"
 * />
 * ```
 */
export default {
    name: 'UiWrapDefaultSlotItem',
    render(h) {
        return h(
            this.isList ? 'ul' : 'div',
            this.slots.filter((item) => !!item.tag).map((vnode, i) => h(this.isList ? 'li' : 'div', {
                class: this.itemClass,
                style: this.itemStyle[i],
                on: {
                    click: (e) => this.onClick(e, i),
                },
            }, [vnode])),
        );
    },
    props: {
        /**
         * Класс для каждого элемента слота (один для всех)
         */
        itemClass: [String, Object],
        /**
         * Стили для каждого элемента слота (для каждого элемента свой)
         */
        itemStyle: {
            type: Array,
            default: () => [],
        },
        /**
         * Массив слотов
         * @type {VNode[]}
         */
        slots: Array,
        /**
         * Будет рендерится с тегом ul, li
         */
        isList: Boolean,
    },
    methods: {
        onClick(e, i) {
            this.$emit('click', [e, i]);
        },
    },
};
</script>
